import { render, staticRenderFns } from "./SearchOrUploadView.vue?vue&type=template&id=2a0108e2&scoped=true"
import script from "./SearchOrUploadView.vue?vue&type=script&lang=js"
export * from "./SearchOrUploadView.vue?vue&type=script&lang=js"
import style0 from "./SearchOrUploadView.vue?vue&type=style&index=0&id=2a0108e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0108e2",
  null
  
)

export default component.exports